export const currencyFormat = '$0,0.00';
